// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"511bcd96","232":"e0c7f4bc","256":"a6326c9a","305":"80d00c21","324":"1c27702a","374":"62b8b198","400":"2654b832","716":"9abd53e6","947":"34d040c5"}[chunkId] + ".chunk.js";
};